export const COUNTER_TEST_ID = "counter-id";
